<template>
  <Catalogs
    title="Виды работ"
    create-text="Новый"
    :fetch-data="fetchData"
    :route-create="'WorkTypeCatalogAdd'"
    :route-edit="'WorkTypeCatalogEdit'"
    :route-view="'WorkTypeCatalogView'"
    :route-path="'/work_type_catalogs'"
    :can-edit="canEditWorkTypeCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "WorkTypeCatalogs",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getWorkTypeCatalogs(data);
    },
    canEditWorkTypeCatalogs() {
      return this.hasPermission([PERM.CATALOG_WORK_TYPE_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/WorkType/WorkTypeCatalogs.vue